import { CartAddEvent } from '@theme/events';

function updateUpsellCount(container) {
  const countEl = container.querySelector('[data-items-count]');
  if (!countEl) return;

  const productForms = container.querySelectorAll('.product-upsell-wrapper form');
  let count = 0;

  productForms.forEach((form) => {
    const variantId = form.querySelector('[ref="variantId"]')?.value;
    if (variantId) count++;
  });

  countEl.textContent = count;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-upsell-container]').forEach(updateUpsellCount);
});

function openDrawerCart() {
  const cartDrawer = document.getElementById('mini-cart');
  const header = document.querySelector('.header-wrapper');

  if (cartDrawer) {
    const activeDrawers = document.querySelectorAll('side-drawer.active');
    activeDrawers.forEach((el) => {
      if (el !== cartDrawer) {
        el.dispatchEvent(new Event('drawer-toggle'));
      }
    });

    if (header) header.classList.remove('header--hidden');
    cartDrawer.dispatchEvent(new Event('drawer-toggle'));
  }
}

document.addEventListener('click', async (event) => {
  const buyAllBtn = event.target.closest('[data-buy-all]');
  if (buyAllBtn) {
    await handleBuyAll(buyAllBtn);
    return;
  }
});

async function handleBuyAll(buyAllBtn) {
  const upsellContainer = buyAllBtn.closest('[data-upsell-container]');
  if (!upsellContainer) return;

  const spinner = buyAllBtn.querySelector('.product-upsell-buy-all__spinner');
  const text = buyAllBtn.querySelector('.product-upsell-buy-all__text');
  const messageEl = upsellContainer.querySelector('[data-upsell-message]');
  const countEl = upsellContainer.querySelector('[data-items-count]');

  const productForms = upsellContainer.querySelectorAll('.product-upsell-wrapper form');
  const itemsData = [];

  productForms.forEach((form) => {
    const variantId = form.querySelector('[ref="variantId"]')?.value;
    if (variantId) {
      itemsData.push({ id: variantId, quantity: 1 });
    }
  });

  if (!itemsData.length) {
    console.warn('No upsell products available for Buy All');
    return;
  }

  buyAllBtn.disabled = true;
  if (text) text.hidden = true;
  if (spinner) spinner.style.display = 'block';
  if (messageEl) messageEl.style.display = 'none';

  try {
    await refreshCart();

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: itemsData }),
    }).then((response) => response.json());

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToUpdate = new Set();

    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });

    document.dispatchEvent(new CartAddEvent({}, itemsData.map(item => item.id).join(','), {
      source: 'upsell-buy-all',
      itemCount: itemsData.length,
      productIds: itemsData.map(item => item.id),
      sections: Array.from(sectionsToUpdate),
      items: itemsData
    }));

    document.dispatchEvent(new CustomEvent('refresh-cart', {
      detail: {
        source: 'upsell-buy-all',
        sourceIds: itemsData.map(item => item.id),
        itemCount: itemsData.length,
        component: upsellContainer
      }
    }));

    openDrawerCart();

  } catch (error) {
    console.error('Buy All error:', error);
    if (messageEl) {
      messageEl.textContent = 'Error adding products to cart. Please try again.';
      messageEl.style.display = 'block';
    }
  } finally {
    buyAllBtn.disabled = false;
    if (text) text.hidden = false;
    if (spinner) spinner.style.display = 'none';
    if (countEl) countEl.textContent = itemsData.length;
  }
}

async function fetchJson(url, options = {}) {
  const fetchOptions = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  };

  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Fetch error ${response.status} on ${url}: ${errorText}`);
  }
  return response.json();
}

async function refreshCart() {
  try {
    await fetchJson('/cart.js');
  } catch (err) {
    console.warn('Cart refresh failed but continuing anyway:', err);
  }
}